import {Logger} from '~shared/modules/logger/models';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare const ineum;

@Injectable({
  providedIn: 'root'
})
export class InstanaStrategy implements Logger {
  constructor() {

  }

  debug(message, data): void {
    ineum('reportEvent',  `debug - ${message}`, {
      timestamp: Date.now(),
      meta: data
    });
  }

  error(error, message): void {
    ineum('reportEvent', `error - ${message}`, {
      timestamp: Date.now(),
      meta: {
        error,
        message,
      }
    });
  }

  info(message, data): void {
    ineum('reportEvent', `info - ${message}`, {
      timestamp: Date.now(),
      meta: data
    });
  }

  warning(message, data): void {
    ineum('reportEvent', `warning - ${message}`, {
      timestamp: Date.now(),
      meta: {
        data, message
      }
    });
  }


}
